import { Action } from 'shared/interface';
import { OffersState } from '../interface/store.interface';
import * as actionTypes from '../store/action-types';

const initialState: OffersState = {
	bonusesActive: [],
	bonusesQueued: [],
	freebetsActive: [],
};

export const OffersReducer = (state: OffersState = initialState, action: Action): OffersState => {
	switch (action.type) {
		case actionTypes.FETCH_BONUSES_AND_FREEBETS_SUCCESS:
			return {
				...state,
				bonusesActive: action.payload.bonusesActive,
				bonusesQueued: action.payload.bonusesQueued,
				freebetsActive: action.payload.freebetsActive,
			};

		case actionTypes.FETCH_BONUSES_AND_FREEBETS_FAIL:
			return {
				...state,
				bonusesActive: initialState.bonusesActive,
				bonusesQueued: initialState.bonusesQueued,
				freebetsActive: initialState.freebetsActive,
			};

		case actionTypes.FETCH_BONUSES_SUCCESS:
			return {
				...state,
				bonusesActive: action.payload.bonusesActive,
				bonusesQueued: action.payload.bonusesQueued,
			};

		case actionTypes.FETCH_BONUSES_FAIL:
			return {
				...state,
				bonusesActive: initialState.bonusesActive,
				bonusesQueued: initialState.bonusesQueued,
			};

		case actionTypes.HIDE_FREEBET:
			return {
				...state,
				freebetsActive: state.freebetsActive.filter((freebet) => {
					return freebet.offerFreebetId !== action.payload.offerFreebetId;
				}),
			};

		default:
			return state;
	}
};
